import css from 'styled-jsx/css';

import { sansSerif } from 'styles/css-constants';
import { sharedPalette } from 'styles/colors/constants';
import { MQ_MEDIUM, MQ_LARGE } from 'constants/mq';

export default css`
  :global(.Modal.ManageRecipeTagsModal) {
    position: absolute;
    top: 15%;
    right: 1rem;
    bottom: auto;
    left: 1rem;
  }

  .ManageRecipeTagsModal :global(.Error__message) {
    font-size: var(--fontScaleNeg2);
    color: red;
  }

  .ManageRecipeTagsModal {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    background: #fff;
    font-family: ${sansSerif};
    text-align: left;
  }

  .ManageRecipeTagsModal__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  .ManageRecipeTagsModal__currentTags {
    padding: 1.25rem;
    max-height: 300px;
    overflow-y: scroll;
  }

  .ManageRecipeTagsModal__currentTags h4 {
    text-transform: uppercase;
  }

  .ManageRecipeTagsModal__currentTags p {
    font-style: italic;
    text-align: center;
    margin: 2.5rem 0;
  }

  @media ${MQ_MEDIUM} {
    :global(.Modal.ManageRecipeTagsModal) {
      top: 50%;
      right: auto;
      bottom: auto;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .ManageRecipeTagsModal {
      height: 300px;
      width: 750px;
    }
  }

  @media ${MQ_LARGE} {
    .ManageRecipeTagsModal {
      height: 300px;
      width: 950px;
    }

    .ManageRecipeTagsModal__currentTags {
      overflow-y: visible;
    }
  }
`;

export const userTagsStyles = css`
  .UserTags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 0.5rem;
  }

  .UserTags__itemContainer {
    margin-bottom: 0.5rem;
  }

  .UserTags__item {
    display: flex;
    align-items: center;
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.35rem 1rem;
    color: #705e5d;
    background: #fff;
    border: 1px solid #705e5d;
    border-radius: 25px;
    margin-right: 0.5rem;
    cursor: pointer;
  }

  .UserTags__item--selected {
    color: #fff;
    background: #321918;
    border: 1px solid #321918;
  }

  .UserTags__item input {
    display: none;
  }
`;

// Styles for bottom form
export const addNewTagsFormStyles = css`
  .ManageRecipeTagsModal__addNewTagsForm {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 130px;
    padding: 1.25rem;
    background: #ebe8e8;
  }

  .ManageRecipeTagsModal__addNewTagsForm h4 {
    text-transform: uppercase;
  }

  .ManageRecipeTagsModal__addNewTagsForm span {
    padding: 0.25rem 0 0.75rem 0;
    color: #5b4746;
    font-size: var(--fontScaleNeg1);
  }

  .ManageRecipeTagsModal__tagsInput {
    padding: 0.5rem;
    font-size: var(--baseFontSize);
    display: block;
    width: 100%;
    border: none;
  }

  .ManageRecipeTagsModal__tagsInput:disabled {
    opacity: 0.75;
  }

  .ManageRecipeTagsModal__submitButton {
    padding: 0.5rem 1.75rem;
    height: 40px;
    border: none;
    background-color: ${sharedPalette.kYellow};
    font-size: 0.75rem;
    cursor: pointer;
  }

  .ManageRecipeTagsModal__submitButton:disabled {
    background-color: ${sharedPalette.lightYellow};
  }

  .ManageRecipeTagsModal__submitButton--isSubmitting {
    position: relative;
  }

  .ManageRecipeTagsModal__submitButton--isSubmitting:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0.725rem;
    bottom: 0;
    display: inline-block;
    vertical-align: bottom;
    width: 0.75em;
    background-color: ${sharedPalette.kYellow};
    overflow: hidden;
    -webkit-animation: animatedEllipsis steps(4, end) 1200ms infinite;
    animation: animatedEllipsis steps(4, end) 1200ms infinite;
  }

  @media ${MQ_LARGE} {
    .ManageRecipeTagsModal__tagsInput {
      padding: 0.75rem 0.5rem;
      font-size: var(--fontScaleNeg1);
    }
  }

  @supports (display: grid) {
    .ManageRecipeTagsModal__tagsInput,
    .ManageRecipeTagsModal__labelText {
      grid-area: input;
    }

    .ManageRecipeTagsModal__tagsInput:focus + .ManageRecipeTagsModal__labelText,
    .ManageRecipeTagsModal__tagsInput:valid + .ManageRecipeTagsModal__labelText,
    .ManageRecipeTagsModal__tagsInput:not(:placeholder-shown)
      + .ManageRecipeTagsModal__labelText {
      display: none;
    }

    .ManageRecipeTagsModal__inputContainer {
      display: flex;
    }

    .ManageRecipeTagsModal__inputWrapper {
      flex: 1 0 auto;
      display: grid;
      grid-template: 'input';
    }

    .ManageRecipeTagsModal__labelText {
      margin: 0.5rem 0;
      display: flex;
      align-items: center;
      padding-left: 0.5rem;
      color: #999;
      font-family: ${sansSerif};
      font-size: var(--fontScaleNeg2);
      pointer-events: none;
    }

    @media (max-width: 47.99rem) {
      .ManageRecipeTagsModal__inputWrapper {
        flex: 1 0 0px;
      }
    }

    @media ${MQ_LARGE} {
      .ManageRecipeTagsModal__labelText {
        font-size: var(--baseFontSize);
      }
    }
  }
`;
